import axios from "axios";
const instance = axios.create({
  baseURL: process.env.VUE_APP_JSON_CDN_DOMAIN,
  timeout: 15000,
});

export default instance;
